<template>
  <div class="topic-type judgment-topic">
    <div class="topic-container">
      <topic-info :info="info" />
      <div class="operation">
        <div class="list" :class="`num${info.ju_num}`">
          <div class="item" v-for="(item, index) in info.list" :key="index">
            <div class="name">{{item.name}}</div>
            <div class="btn-group">
              <div class="btn yes" :class="{ active: getAnswerStatus(item.id, 1) }" @click="choice(1, item)">
                <van-icon name="success" />
              </div>
              <div class="btn no" :class="{ active: getAnswerStatus(item.id, 0) }" @click="choice(0, item)">
                <van-icon name="cross" />
              </div>
            </div>
          </div>
          <div class="zw" v-for="(i, ind) in 3" :key="'zw' + ind"></div>
        </div>
      </div>
    </div>
    <!-- 指令 -->
    <div class="instruction-container" v-if="info.edict">
      <div class="content" :class="{open: instructionShow}">
        <p v-show="instructionShow">{{ info.edict }}</p>
        <van-icon name="arrow-left" v-show="instructionShow" @click="instructionShow = false" />
      </div>
      <div class="btn" @click="instructionShow = true">
        <img src="@/assets/img/instruction.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import TopicInfo from "../TopicInfo";
export default {
  name: "JudgmentTopic",
  components: {
    TopicInfo
  },
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    topicInfo: {
      type: Object,
      required: true
    },
    isHand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      info: {},
      score: 0,
      instructionShow: false,
      answerRecord: []
    }
  },
  watch: {
    value: {
      handler(val) {
        this.score = val;
      },
      immediate: true
    }
  },
  created() {
    this.info = this.$route.query.topic_sort * 1 > 0 ? this.topicInfo.topic_info : this.topicInfo;
    // 初始化答题记录
    if (this.topicInfo.son_toprecrd) {
      this.answerRecord = this.topicInfo.son_toprecrd.map(record => ({
        id: record.id,
        topic_id: record.topic_id,
        answer: record.answer * 1
      }));
    }
  },
  methods: {
    choice(val, item) {
      let index = this.answerRecord.findIndex(e => e.topic_id * 1 === item.id * 1)
      if (index > -1) {
        if (this.answerRecord[index].id || this.answerRecord[index].answer !== val) {
          this.answerRecord[index].answer = this.answerRecord[index].answer === val ? '' : val
        }else{
          this.answerRecord.splice(index, 1)
        }
      } else {
        this.answerRecord.push({
          id: '',
          topic_id: item.id,
          answer: val
        })
      }
      if (this.isHand) {
        this.$emit('update:isHand', false);
      }
      this.calculateScore();
    },
    getAnswerStatus(topicId, answerValue) {
      const record = this.answerRecord.find(item => item.topic_id * 1 === topicId * 1);
      return record && record.answer !== '' && record.answer * 1 === answerValue * 1;
    },
    // 计算分数
    calculateScore() {
      if (this.isHand) return;
      let choiceNum = this.answerRecord.filter(item => item.topic_id).length;
      if (choiceNum === 0) {
        this.score = '';
      } else {
        const yesNum = this.answerRecord.filter(item => item.topic_id && item.answer * 1 === 1).length;
        if (yesNum >= this.info.full_mark * 1) {
          this.score = 1;
        } else if (yesNum >= this.info.half_mark * 1) {
          this.score = 0.5;
        } else {
          this.score = 0;
        }
      }
      this.$emit('input', this.score);
    },
  },
}
</script>

<style lang="less" scoped>
.operation {
  // height: 3rem;
  flex: 1;
  padding: 0.2rem 0.15rem;
  overflow-y: scroll;
  .list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .item {
      display: flex;
      align-items: center;
      background: linear-gradient(351deg, #fff6e5 0%, #ffebd4 100%);
      border-radius: 0.12rem;
      border: 1px solid #ffcd94;
      padding: 0.06rem 0.12rem;
      margin: 0 0.11rem 0.1rem;
      width: 62%;
      .name {
        flex: 1;
        font-size: 0.14rem;
        color: #630200;
      }
      .btn-group {
        display: flex;
        align-items: center;
        .btn {
          width: 0.48rem;
          height: 0.32rem;
          background: linear-gradient(180deg, #fedd99 0%, #ffeecb 100%);
          border-radius: 0.16rem;
          border: 1px solid #ffd98b;
          text-align: center;
          line-height: 0.32rem;
          font-size: 0.2rem;
          color: #630200;
          margin-left: 0.12rem;
          &.yes.active {
            background: linear-gradient(180deg, #77c700 0%, #3d9f05 100%);
            border: none;
            color: #fff;
          }
          &.no.active {
            background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
            border: none;
            color: #fff;
          }
        }
      }
    }
    .zw {
      width: 62%;
      margin: 0 0.11rem;
    }
    &.num1 .item {
      width: 62%;
    }
    &.num2 .item,
    &.num2 .zw {
      width: 47%;
    }
    &.num3 .item,
    &.num3 .zw {
      width: 30%;
    }
  }
}
.instruction-container {
  min-width: 0.46rem;
  height: 0.46rem;
  position: fixed;
  bottom: 1rem;
  left: 0;
  border-radius: 0.23rem;
  .content {
    width: 0;
    height: 0.43rem;
    background: linear-gradient(205deg, #ffecd6 0%, #ffda95 100%);
    border-radius: 0 0.2rem 0.2rem 0;
    border: 1px solid #ffc767;
    font-size: 0.12rem;
    color: #540200;
    line-height: 0.14rem;
    position: absolute;
    left: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    transition: all 0.1s ease;
    box-sizing: border-box;
    p {
      // 限制最多显示两行
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-all;
    }
    .van-icon {
      color: #f59f0c;
      font-size: 0.14rem;
      margin-left: 0.05rem;
    }
    &.open {
      width: max-content;
      max-width: 3rem;
      padding: 0 0.15rem 0 0.3rem;
    }
  }
  .btn {
    width: 0.46rem;
    height: 0.46rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>